module.exports = __webpack_public_path__ + "static/media/announce_character.8c3511c5.png";